<template>
  <section class="doctor-comment">
    <span class="doctor-comment__title">{{ $t('skincare.doctorComment.title') }}</span>
    <p class="doctor-comment__subtitle">{{ $t('skincare.doctorComment.description') }}</p>
    <textarea
      v-model="comment"
      class="doctor-comment__input rounded-input"
      :maxlength="MAX_LENGTH"
      :placeholder="$t('skincare.doctorComment.placeholder')"
      rows="3"
    />
    <div class="doctor-comment__counter">{{ comment.length }} / {{ MAX_LENGTH }}</div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import get from 'lodash/get';

import { types as dashTypes } from '@/modules/dashboard/store/types';

const MAX_LENGTH = 1000;

export default {
  name: 'DoctorCommentSection',
  data() {
    return { MAX_LENGTH };
  },
  computed: {
    ...mapGetters({ summaryTreatment: dashTypes.getters.SUMMARY_TREATMENT }),
    comment: {
      get() {
        return get(this.summaryTreatment, 'doctorComment', '') || '';
      },
      set(value) {
        this.updateSummaryTreatment({ doctorComment: value });
      }
    }
  },
  methods: {
    ...mapActions({ updateSummaryTreatment: dashTypes.actions.UPDATE_SUMMARY_TREATMENT })
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/common/inputs';
@import '../../../../assets/scss/helpers/colors';

.doctor-comment {
  display: block;
  margin-top: 20px;
  padding: 20px;
  background-color: $white;
  border: 1px solid $background;
  border-radius: 8px;

  &__title {
    font-size: 15px;
    font-weight: 500;
    color: $main-title-color;
  }

  &__subtitle {
    margin: 5px 0 12px;
    font-size: 13px;
    color: $grey-color;
  }

  &__input {
    width: 100%;
    min-height: 80px;
    padding: 10px 15px;
    font-size: 15px;
    box-sizing: border-box;
    resize: vertical;
  }

  &__counter {
    margin-top: 6px;
    text-align: right;
    font-size: 12px;
    color: $grey-color;
  }
}
</style>
